module.exports = __webpack_public_path__ + "static/media/preparation.2ec20dbe.svg";